/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH under
 * one or more contributor license agreements. See the NOTICE file distributed
 * with this work for additional information regarding copyright ownership.
 * Licensed under the Camunda License 1.0. You may not use this file
 * except in compliance with the Camunda License 1.0.
 */

export const genericErrorMessage = 'Something went wrong on our end. Please try again.';

const promptTooLong = 'This text prompt is too long. Please try again with a shorter prompt.';

const otherPartsTooLong =
  'The expression, context, or diagram variables list are too long. Please try again with a smaller expression or context, or run your query in a less complex diagram.';

const textEncoder = new TextEncoder();

export const getInputTooLongMessage = (request) => {
  const promptLength = textEncoder.encode(JSON.stringify(request.prompt)).length;
  const totalRequestLength = textEncoder.encode(JSON.stringify(request)).length;

  const promptMakesUpMostOfTheRequest = promptLength > totalRequestLength / 2;
  return promptMakesUpMostOfTheRequest ? promptTooLong : otherPartsTooLong;
};
